import { render } from "./CreatePassForm.vue?vue&type=template&id=11e33b3a"
import script from "./CreatePassForm.vue?vue&type=script&lang=js"
export * from "./CreatePassForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__